import { action, observable } from 'mobx';
import { EEvent } from '@pes-ui/utils/lib/constants/comparator-events';
import { getComparisonSessionId, comparator } from '@pes-ui/components/dist/collection/globals/common/comparator';
import { buildURL } from '@pes-ui/utils';
import { COMPARATOR_URL } from '../../common/constants';
import { ADD_TO_COMPARE, REMOVE_FROM_COMPARE, MAX_PRODUCTS } from '../../constants/constants';
import { REPLATFORMED_COMPARATOR_URL } from '@pes-ui/utils/lib/constants';

export class ComparatorStore {
  @observable comparatorArr = [];

  @observable isComparatorFull = false;

  @observable comparatorUrlLink = '';

  @observable comparisonPageEnabled = false;

  comparatorMaxItems = 4;
  comparatorUrl = '';

  rootStore = null;
  constructor(rootStore) {
    this.rootStore = rootStore;
    this.comparatorMaxItems =
      this.rootStore.services.comparatorAPI.maxQty ?? this.comparatorMaxItems;
    this.rootStore.services.comparatorAPI.setActionCallBack(this.replaceComparatorArr);
    const comparatorEndpoint = this.rootStore.isPublic ? COMPARATOR_URL : REPLATFORMED_COMPARATOR_URL;
    this.comparatorUrl = buildURL({
      endpoint: `${comparatorEndpoint}/${getComparisonSessionId()}`,
      ...this.rootStore.localeObj,
    });
    this.appendProductsToComparatorUrl();
    window.addEventListener(EEvent.COMPARATOR_PRODUCTS_CHANGE, this.appendProductsToComparatorUrl);
  }
  @action.bound
  appendProductsToComparatorUrl() {
    const productIds = this.rootStore.services.comparatorAPI.getStoredProductIds().join('|');
    this.comparatorUrlLink = `${this.comparatorUrl}/${encodeURIComponent(productIds)}`;
  }

  @action.bound
  replaceComparatorArr(newArr) {
    this.comparatorArr.replace(newArr);
    this.isComparatorFull = this.comparatorArr.length >= this.comparatorMaxItems;
  }

  addToCompare = (skuID) => {
    this.rootStore.services.comparatorAPI.add({ productId: skuID });
    if (comparator.isFull()) {
      this.rootStore.uiStore.showNotification(MAX_PRODUCTS);
    } else {
      this.rootStore.uiStore.showNotification(ADD_TO_COMPARE);
    } 
  };

  removeFromCompare = (skuID) => {
    this.rootStore.services.comparatorAPI.remove(skuID);
    this.rootStore.uiStore.showNotification(REMOVE_FROM_COMPARE);
  };
}